import React from "react";
import Select from "react-select";
import styles from "./SlideCompositionPage.local.scss";
import { connect } from "react-redux";
import { addComponentIndicator } from "Actions";
class Autocomplete extends React.Component {
  constructor() {
    super();
    this.state = {
      selectedOption: null
    };
  }
  handleChange = valeur => {
    const { dispatch } = this.props;
    if (valeur) {
      let labelValue = valeur.label.substr(valeur.label.lastIndexOf(":") + 1);
      const code = { label: labelValue, value: valeur.value };
      this.setState({ selectedOption: code });
      let newIndicator = [];
      newIndicator.push(code.value);
      this.props.addSlideIndicators(
        this.props.indicatorNum,
        code.value.slice(1)
      );
      this.props.addComponentIndicator(
        this.props.indicatorNum,
        code.value.slice(1)
      );
    } else {
      this.setState({ selectedOption: null });
      const {
        configComponent: { indicators }
      } = this.props;
      let newIndicator = indicators;

      // delete newIndicator[this.props.indicatorNum];
      newIndicator.splice(this.props.indicatorNum, 1);
      dispatch(addComponentIndicator(newIndicator));
    }
  };
  render() {
    const { selectedOption } = this.state;
    const { indicateurs } = this.props;
    const options =
      indicateurs &&
      indicateurs.map(indicat => {
        const indicator = indicat.code.concat(" : ".concat(indicat.label.fr));
        return { label: indicator, value: indicat.code };
      });
    let updateLabel = "";
    if (this.props.indicatorUpdate[this.props.indicatorNum]) {
      indicateurs &&
        indicateurs.map(indicat => {
          if (
            indicat.code.slice(1) ===
            this.props.indicatorUpdate[this.props.indicatorNum]
          ) {
            updateLabel = indicat.label.fr;
          }
        });
    }
    let updated = {
      label: updateLabel ? updateLabel : "",
      value: this.props.indicatorUpdate[this.props.indicatorNum]
        ? this.props.indicatorUpdate[this.props.indicatorNum]
        : ""
    };
    return (
      <Select
        value={
          updated.label && this.props.update === "UPDATE"
            ? updated
            : selectedOption
        }
        onChange={this.handleChange}
        options={options}
        className={styles.input_indicator}
        classNamePrefix="ttp-select"
        width={"12px"}
        isClearable={true}
      />
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  fetched: state.indicators.fetched,
  suggestions: state.indicators.suggestions.items,
  selectedComponent: state.slideComposition.composition.selectedComponent,
  composition: state.slideComposition.composition,
  update: state.slideComposition.ComponentAction,
  configComponent: state.slideComposition.componentConfig
});

export default connect(mapStateToProps)(Autocomplete);



// WEBPACK FOOTER //
// ./src/components/SlideComposition/Autocomplete.js